export default __webpack_public_path__ + "static/media/trr-food-pastry-15.29b50c73.png";